// NovoAnuncioMkt.js  (SEM MODAL)
// - mantém o combo de canais/categorias vinculadas
// - ao clicar "Criar anúncio" abre a área de criação INLINE (igual antes)
// - preço normal agora é EDITÁVEL (InputNumber)
// - promo opcional igual
import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Col,
  Row,
  Space,
  Spin,
  Typography,
  message,
  Select,
  Tag,
  DatePicker,
  Input,
  Checkbox,
  InputNumber,
  Divider
} from 'antd';
import axios from 'axios';
import { MoneyInput } from '../../../../Componentes/MoneyInput';
import Metafields from './Metafields';
import { useConfigQuery } from '../../../../queries/useConfig';

const { Text, Title } = Typography;

const NovoAnuncioMkt = ({ cnpj, voltar, produto, ads = [], setProduto }) => {
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = window?.localStorage?.getItem("accessToken");
  const { data: config } = useConfigQuery();
  const [metafields, setMetafields] = useState([]);
  const [selectedChannelId, setSelectedChannelId] = useState(null);

  useEffect(() => {
    const carregarMetafields = async () => {
      if (!selectedChannelId) {
        return;
      }
      let inicial = [];

      // 1) Tenta buscar do novo endpoint metafields-mkt
      try {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + accessToken,
          },
        };

        const resp = await axios.get(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/${config.idLoja}/metafields-mkt/id_ref_prod_cat/${produto.id}/P/${selectedChannelId}`,
          options
        );

        const data = resp.data;

        if (
          data &&
          typeof data.metafields === 'string' &&
          data.metafields.trim() !== ''
        ) {
          try {
            const parsed = JSON.parse(data.metafields);


            if (Array.isArray(parsed)) {
              inicial = parsed;
            } else {
              console.warn('metafields do endpoint não é array após o parse:', parsed);
            }
          } catch (e) {
            console.error('Erro ao converter data.metafields do endpoint:', e);
          }
        }
      } catch (err) {
        console.error('Erro ao buscar metafields_mkt no endpoint novo:', err);
      }


      // 3) Monta estrutura com ids para a tela
      const comIds = (inicial.length ? inicial : []).map((mf, index) => ({
        id: `${Date.now()}-${index}`,
        key: mf?.key || '',
        value: mf?.value || '',
      }));

      if (comIds.length === 0) {
        comIds.push({
          id: `${Date.now()}-0`,
          key: '',
          value: '',
        });
      }

      setMetafields(comIds);
    };

    if (produto?.id && config?.idLoja && accessToken) {
      carregarMetafields();
    }
  }, [
    accessToken, produto, selectedChannelId
  ]);






  // ============================= Constantes ============================= //
  const TOKEN = 'FQNTb2bzbXttAkrGHDS5GSy7lAtjIwx5Yog3tXWwy3s';
  const API_BASE = 'https://apimarket.pedtech.com.br/v1';

  // ============================= Helpers ============================= //
  const S = (v) => (v == null ? '' : String(v));

  const toNumberOrZero = (v) => {
    const n = Number(v);
    return Number.isNaN(n) ? 0 : n;
  };

  const round2 = (v) => {
    const n = toNumberOrZero(v);
    return Number(Math.round(n * 100) / 100);
  };

  const formatCurrencyBR = (v) =>
    round2(v).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const formatCurrencyBRCents = (cents) => formatCurrencyBR((cents || 0) / 100);

  const addSet = (set, v) => { const n = new Set(set); n.add(v); return n; };
  const delSet = (set, v) => { const n = new Set(set); n.delete(v); return n; };

  // ============================= Estado ============================= //
  const [loading, setLoading] = useState(false);

  // canais e histórico
  const [channels, setChannels] = useState([]); // [{ salesChannelId, nome, sellerId, ... }]
  const [historicoMap, setHistoricoMap] = useState(new Map()); // Map<channelId, Set<categoryId>>
  const [labelsByChannel, setLabelsByChannel] = useState(new Map()); // Map<channelId, Map<categoryId, text>>
  const [labelsLoading, setLabelsLoading] = useState(new Set()); // Set<channelId>

  // seleção global (um combo só)

  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  // dados de anúncio
  const [tipo, setTipo] = useState('CLASSICO');

  // ✅ preço base EDITÁVEL
  const [precoBase, setPrecoBase] = useState(round2(produto?.preco ?? produto?.price ?? 0));

  const [isPromo, setIsPromo] = useState(false);
  const [inicioPromo, setInicioPromo] = useState(null);
  const [fimPromo, setFimPromo] = useState(null);
  const [precoPromoCents, setPrecoPromoCents] = useState(0); // centavos

  // controle de exibição do formulário inline
  const [showForm, setShowForm] = useState(false);

  // infos da seleção (pra mostrar no form)
  const [formChannel, setFormChannel] = useState(null);
  const [formCatLabel, setFormCatLabel] = useState('');
  const [nomeDoCanalNoMkt, setNomeDoCanalNoMkt] = useState('');

  // mantém precoBase sincronizado quando muda o produto
  useEffect(() => {
    setPrecoBase(round2(produto?.preco ?? produto?.price ?? 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [produto?.preco, produto?.price, produto?.id]);

  // ============================= API ============================= //
  async function fetchHistoricoAssociacao() {
    const url = `${API_BASE}/historico-associacao/${produto?.categoria?.id}/${cnpj}`;
    const headers = { token: TOKEN };
    const { data } = await axios.get(url, { headers });

    const map = new Map();
    for (const h of (data || [])) {
      const ch = S(h.idSaleChannel);
      const nomeCat = S(h.nomeCategoriaSaleChannel);
      const cat = S(h.idCategoriaSaleChannel);
      if (!map.has(ch)) map.set(ch, new Set());
      if (cat) map.get(ch).add(cat);
      if (nomeCat) map.get(ch).add(nomeCat);
    }
    setHistoricoMap(map);
    return map;
  }

  async function fetchChannelsDaLoja() {
    const url = `${API_BASE}/saleschannelloja/${cnpj}`;
    const headers = { token: TOKEN };
    const { data } = await axios.get(url, { headers });
    return data || [];
  }

  async function fetchRootCategories(channelId) {
    const url = `${API_BASE}/categorias/canal/${channelId}/${cnpj}`;
    const headers = { token: TOKEN };
    const { data } = await axios.get(url, { headers });
    return data || [];
  }

  async function fetchChildren(channelId, parentId) {
    const url = `${API_BASE}/categorias/canal/${channelId}/childrens/${parentId}/${cnpj}`;
    const headers = { token: TOKEN };
    const { data } = await axios.get(url, { headers });
    return data || [];
  }

  async function resolveLabelsForChannel(channelId, idsSet) {
    const ids = Array.from(idsSet || []);
    if (ids.length === 0) return new Map();

    const cacheForCh = labelsByChannel.get(channelId) || new Map();
    const missing = ids.filter((id) => !cacheForCh.has(id));
    if (missing.length === 0) return cacheForCh;

    setLabelsLoading((prev) => addSet(prev, channelId));
    try {
      const found = new Map(cacheForCh);
      const queue = [];
      let requestsCount = 0;
      const LIMIT = 500;

      const roots = await fetchRootCategories(channelId);
      requestsCount++;
      for (const n of roots) {
        if (missing.includes(S(n.id))) found.set(S(n.id), n.text || S(n.id));
        if (n.children) queue.push({ id: S(n.id) });
      }

      const stillMissing = () => missing.filter((id) => !found.has(id));

      /*
      while (stillMissing().length && queue.length && requestsCount < LIMIT) {
        const cur = queue.shift();
        const children = await fetchChildren(channelId, cur.id);
        requestsCount++;
        for (const child of children) {
          const cid = S(child.id);
          if (missing.includes(cid)) found.set(cid, child.text || cid);
          if (child.children) queue.push({ id: cid });
        }
      }
      */

      for (const m of missing) if (!found.has(m)) found.set(m, m);

      setLabelsByChannel((prev) => {
        const copy = new Map(prev);
        copy.set(channelId, found);
        return copy;
      });
      return found;
    } catch (e) {
      console.error('Resolver labels falhou', e);
      message.error(`Falha ao resolver categorias do canal #${channelId}`);
      const fallback = new Map();
      for (const m of ids) fallback.set(m, m);
      const merged = new Map([...(labelsByChannel.get(channelId) || new Map()), ...fallback]);
      setLabelsByChannel((prev) => {
        const copy = new Map(prev);
        copy.set(channelId, merged);
        return copy;
      });
      return merged;
    } finally {
      setLabelsLoading((prev) => delSet(prev, channelId));
    }
  }

  // ============================= Efeitos ============================= //
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const hist = await fetchHistoricoAssociacao();
        const canais = await fetchChannelsDaLoja();

        const canaisComVinculo = (canais || []).filter((ch) => {
          const chId = S(ch.salesChannelId);
          return hist.has(chId) && hist.get(chId)?.size > 0;
        });
        setChannels(canaisComVinculo);

        for (const ch of canaisComVinculo) {
          const chId = S(ch.salesChannelId);
          const idsSet = hist.get(chId);
          resolveLabelsForChannel(chId, idsSet);
        }
      } catch (e) {
        console.error(e);
        message.error('Erro ao carregar dados dos canais');
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cnpj, produto?.categoria?.id]);

  // ============================= Options do combo único ============================= //
  const globalOptions = (() => {
    const opts = [];
    const adsIdsSet = new Set(ads.map(ad => String(ad.saleschannelid)));

    for (const ch of channels) {
      const chId = S(ch.salesChannelId);
      const chName = ch.nome;

      if (adsIdsSet.has(chId)) continue;

      const idsSet = historicoMap.get(chId) || new Set();
      const labelMap = labelsByChannel.get(chId) || null;

      if (idsSet instanceof Set && idsSet.size === 2) {
        const [catId, catLabel] = Array.from(idsSet);
        opts.push({
          value: `${chId}:${catId}`,
          label: `${chName} — ${catLabel}`,
          channelId: chId,
          categoryId: String(catId),
        });
        continue;
      }

      for (const entry of idsSet) {
        let catId, catLabel;

        if (entry instanceof Set || Array.isArray(entry)) {
          const arr = [...entry];
          catId = arr[0];
          catLabel = arr[1];
        } else {
          if (/^MLB\d+$/.test(entry)) continue;
          catId = entry;

          const fromMap =
            labelMap && typeof labelMap.get === 'function'
              ? labelMap.get(catId)
              : null;

          catLabel = fromMap || entry;
        }

        opts.push({
          value: `${chId}:${catId}`,
          label: `${chName} — ${catLabel}`,
          channelId: chId,
          categoryId: String(catId),
        });
      }
    }

    return opts.sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
  })();


  const buscarNomeDaCategoria = (value) => {
    console.log(value);

    /*
          const idsSet = historicoMap.get(chId) || new Set();
          const labelMap = labelsByChannel.get(chId) || null;
    
          if (idsSet instanceof Set && idsSet.size === 2) {
            const [catId, catLabel] = Array.from(idsSet);
            opts.push({
              value: `${chId}:${catId}`,
              label: `${chName} — ${catLabel}`,
              channelId: chId,
              categoryId: String(catId),
            });
            continue;
          }*/

  }

  const handleSelectGlobal = (value) => {

    const [chId, catId] = String(value).split(':');

    console.log('Escolhi algo');
    console.log(value);
    console.log(ads);
    console.log(historicoMap);

    const idsSet = historicoMap.get(chId) || new Set();

    if (idsSet instanceof Set && idsSet.size === 2) {
      const [catId, catLabel] = Array.from(idsSet);
      setNomeDoCanalNoMkt(catLabel || '');
    }
    setSelectedChannelId(chId);
    setSelectedCategoryId(catId);
    setShowForm(false); // se trocar seleção, fecha form até clicar criar
  };

  // ============================= Currency handlers ============================= //
  const handlePrecoPromoKeyDown = (e) => {
    const { key } = e;

    if (['Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(key)) return;

    if (/^[0-9]$/.test(key)) {
      e.preventDefault();
      setPrecoPromoCents((prev) => {
        const base = Number.isFinite(prev) ? prev : 0;
        const next = base * 10 + Number(key);
        if (next > 9999999999) return base;
        return next;
      });
      return;
    }

    if (key === 'Backspace') {
      e.preventDefault();
      setPrecoPromoCents((prev) =>
        Math.floor((Number.isFinite(prev) ? prev : 0) / 10)
      );
      return;
    }

    if (key === 'Delete') {
      e.preventDefault();
      setPrecoPromoCents(0);
      return;
    }

    e.preventDefault();
  };

  const buscarMetafields = async () => {
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      const resp = await axios.get(
        `https://techspdv-api-d3e739785e34.herokuapp.com/v1/${config.idLoja}/metafields-mkt/id_ref_prod_cat/${produto.id}/P/${selectedChannelId}`,
        options
      );

      if (resp.status == 200 && resp.data.metafields != '') {
        return resp.data.metafields;
      } else {
        const resp = await axios.get(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/${config.idLoja}/metafields-mkt/id_ref_prod_cat/${produto.categoria.id}/C/${selectedChannelId}`,
          options
        );
        if (resp.status == 200) {
          return resp.data.metafields;
        } else {
          return [];
        }
      }
    } catch (error) {

    }
  }

  const normalizeMetafields = (raw) => {
    console.log(raw);
    if (typeof raw === 'string') {
      const trimmed = raw.trim();
      if (!trimmed) return [];

      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        console.error('metafields string não é JSON válido:', e);
        return [];
      }
    }

    // se já vier como array
    if (Array.isArray(raw)) {
      return raw;
    }

    return [];
  };

  // ============================= Payload e criação ============================= //
  const buildPayload = async () => {
    const imagens = [];
    if (produto?.img1) imagens.push(`https://api.pedtech.com.br/imagens/${produto.img1}`);
    if (produto?.img2) imagens.push(`https://api.pedtech.com.br/imagens/${produto.img2}`);
    if (produto?.img3) imagens.push(`https://api.pedtech.com.br/imagens/${produto.img3}`);
    if (produto?.img4) imagens.push(`https://api.pedtech.com.br/imagens/${produto.img4}`);

    const ch = channels.find((c) => S(c.salesChannelId) === S(selectedChannelId));
    const basePrice = round2(precoBase);

    const salesChannel = {
      id: Number(selectedChannelId),
      price: basePrice,
      listingType: tipo,
      sellerId: ch?.sellerId ? String(ch.sellerId) : '',
    };

    if (isPromo && precoPromoCents > 0 && inicioPromo && fimPromo) {
      const promoPrice = round2(precoPromoCents / 100);
      salesChannel.forSale = {
        salePrice: promoPrice,
        saleDateStart: inicioPromo.toISOString?.() || inicioPromo,
        saleDateEnd: fimPromo.toISOString?.() || fimPromo,
      };
    }

    const metafildsDoProduto = await buscarMetafields();

    return {
      productId: S(produto?.id || 'PRODUTO_SEM_ID'),
      productName: S(produto?.nome || produto?.name || ''),
      sku: S(produto?.sku || ''),
      name: S(produto?.nome || produto?.name || ''),
      brand: S(produto?.marca || produto?.brandMkt || 'SEM MARCA'),
      description: S(produto?.descricao || produto?.description || ''),
      price: produto?.preco,
      stock: Number(produto?.quantidade_estoque ?? produto?.stock ?? 1),
      width: Number(produto?.width ?? produto?.largura ?? 1),
      height: Number(produto?.height ?? produto?.altura ?? 1),
      length: Number(produto?.length ?? produto?.comprimento ?? 1),
      weight: Number(produto?.weight ?? produto?.peso ?? 1),
      active: produto?.ativo != null ? Boolean(produto.ativo) : true,

      model: S(produto?.modelo || produto?.model || 'Padrão'),
      anatelCode: S(produto?.anatelCode || ''),

      customCategory: {
        alternativeId: S(produto?.categoria?.id || ''),
      },

      salesChannels: [salesChannel],
      images: imagens,
      metafields: normalizeMetafields(metafildsDoProduto),
    };
  };

  function extractErrorMessages(data) {
    if (!data?.error_messages) return null;

    const mensagens = data.error_messages
      .flatMap((item) => item.message || [])
      .map((m) => (m.field ? `${m.field}: ${m.message}` : m.message || String(m)));

    return mensagens;
  }

  function extractErrorMessages(data) {
    if (!data?.error_messages) return null;

    const mensagens = data.error_messages
      .flatMap((item) => item.message || [])
      .map((m) => (m.field ? `${m.field}: ${m.message}` : m.message || String(m)));

    return mensagens;
  }

  const criarAnuncio = async () => {
    // setIsLoading(true);
    const payload = await buildPayload();
    console.log(payload);

    try {
      const headers = { token: TOKEN };
      const url = `${API_BASE}/produtos/receberProduto/${cnpj}`;
      const resp = await axios.post(url, payload, { headers });

      if (resp.status >= 200 && resp.status < 300) {
        message.success('Anúncio criado com sucesso!');

        if (!produto.temMkt) {
          const options = {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          };
          const respAttTemMkt = await axios.put(`https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/a992b030-a5a5-4c85-9211-f5230501e8f7/produtos/atualizarMkt/${produto.id}/true`, {}, options);
          if (respAttTemMkt.status === 200 || respAttTemMkt.status === 204) {
            setProduto(respAttTemMkt.data);
          }

          console.log(respAttTemMkt.data);
        }
        voltar();
      } else {
        message.warning(`Resposta inesperada: ${resp.status}`);
      }
    } catch (err) {

      // Uso no catch:
      if (err.status === 400) {
        const msgs = extractErrorMessages(err?.response?.data);
        if (msgs && msgs.length) {
          message.error(msgs.join('\n'));
          return;
        }
      }
      console.error(err);
      const detail =
        err?.response?.data?.message || err?.message || 'Falha ao criar anúncio.';
      message.error(detail);
    } finally {
      setIsLoading(false);
    }
  };

  const abrirFormulario = () => {
    const ch = channels.find((c) => S(c.salesChannelId) === S(selectedChannelId));
    const labelMap = labelsByChannel.get(S(selectedChannelId)) || new Map();
    const catLabel = labelMap.get(S(selectedCategoryId)) || S(selectedCategoryId);

    setFormChannel(ch || null);
    setFormCatLabel(catLabel || '');


    // reseta promo ao abrir
    setIsPromo(false);
    setPrecoPromoCents(0);
    setInicioPromo(null);
    setFimPromo(null);

    // reseta preço pro preço do produto
    setPrecoBase(round2(produto?.preco ?? produto?.price ?? 0));

    setShowForm(true);
  };

  // ============================= Render ============================= //
  const isAnyLabelsLoading = labelsLoading.size > 0;

  return (
    isLoading ? (<div style={styles.wrap}><Spin
      spinning={isLoading}
      tip={<span style={{ fontSize: 16, fontWeight: '500', color: '#333' }}>Carregando...</span>}
      size="large"
    /></div>) : <div style={styles.wrap}>
      < Row gutter={[16, 16]} >
        <Col span={24}>
          <Card
            title={(
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Space>
                  <Button type="primary" onClick={voltar} style={{ background: '#000', borderColor: '#000' }}>
                    Voltar
                  </Button>
                  <Text type="secondary">
                    Selecione uma categoria <b>já vinculada</b> (o combo mostra o marketplace).
                  </Text>
                </Space>
                <Button
                  type="primary"
                  style={{ background: '#000', borderColor: '#000' }}
                  onClick={abrirFormulario}
                  disabled={!selectedChannelId || !selectedCategoryId}
                >
                  Criar anúncio
                </Button>
              </div>
            )}
            bodyStyle={{ padding: 12 }}
          >
            {loading ? (
              <div style={styles.center}><Spin /></div>
            ) : (
              <Space direction="vertical" style={{ width: '100%' }} size={12}>
                <Text type="secondary">Categoria vinculada (com marketplace)</Text>
                <Select
                  showSearch
                  placeholder={globalOptions.length
                    ? 'Selecione marketplace — categoria'
                    : 'Nenhum vínculo encontrado'}
                  optionFilterProp="label"
                  options={globalOptions}
                  onChange={handleSelectGlobal}
                  value={
                    selectedChannelId && selectedCategoryId
                      ? `${selectedChannelId}:${selectedCategoryId}`
                      : undefined
                  }
                  style={{ width: '100%' }}
                  loading={isAnyLabelsLoading}
                />
              </Space>
            )}
          </Card>
        </Col>

        {/* ===== FORM INLINE (SEM MODAL) ===== */}
        {
          showForm && (
            <Col span={24}>
              <Card
                style={{ borderRadius: 12 }}
                title={
                  <Space direction="vertical" size={0}>
                    <Title level={5} style={{ margin: 0 }}>Criar anúncio</Title>
                    <Text type="secondary">
                      Canal: {formChannel?.nome || selectedChannelId} — Categoria: {nomeDoCanalNoMkt}
                    </Text>
                  </Space>
                }
                extra={
                  <Space>
                    <Button onClick={() => setShowForm(false)}>
                      Cancelar
                    </Button>
                    <Button
                      type="primary"
                      style={{ background: '#000', borderColor: '#000' }}
                      onClick={criarAnuncio}
                      loading={isLoading}
                    >
                      Salvar Anúncio
                    </Button>
                  </Space>
                }
              >
                <Text strong>{S(produto?.nome || produto?.name || produto?.id)}</Text>
                <br /><br />

                <div>
                  <Tag color="blue">
                    <b>{formChannel?.nome || 'Canal'}: {selectedChannelId}</b>
                  </Tag>
                  <Tag>
                    <b style={{ color: "#3f3f3fff" }}>{formCatLabel}</b>
                  </Tag>
                </div>

                <Divider />

                {/* Tipo */}
                <b>Tipo:</b>{' '}
                <Input
                  value={tipo}
                  onChange={(e) => setTipo(e.target.value)}
                  style={{ maxWidth: 200 }}
                  disabled
                />
                <br /><br />

                {/* ✅ Preço normal EDITÁVEL */}
                <b>Preço de vendaa:</b>

                <MoneyInput
                  className="input-estilizado"
                  value={precoBase}
                  prefix="R$"
                  onChange={setPrecoBase}
                  style={{
                    width: 100,
                    marginLeft: 10,
                    height: 25,                 // mesma altura padrão do Ant Input
                    padding: '4px 11px',
                    fontSize: 14,
                    lineHeight: '22px',
                    color: 'rgba(0,0,0,0.88)',
                    backgroundColor: '#fff',
                    border: '1px solid #d9d9d9',
                    borderRadius: 6,
                    outline: 'none',
                    boxShadow: 'none',
                    transition: 'all .2s',
                  }}
                />
                <br /><br />
                <Metafields elemento={produto} tipo={'P'} canal={selectedChannelId} setElemento={setProduto} metafields={metafields} setMetafields={setMetafields}></Metafields>
                <div style={{ marginBottom: 10 }}>

                  <Checkbox
                    checked={isPromo}
                    onChange={(e) => setIsPromo(e.target.checked)}
                  >
                    Cadastrar preço promocional
                  </Checkbox>
                </div>

                {isPromo && (
                  <div style={{ border: '1px solid #ddd', padding: 10, borderRadius: 6 }}>
                    <b>Preço Promocional:</b>
                    <Input
                      style={{ width: '100%', marginTop: 4 }}
                      addonBefore="R$"
                      value={formatCurrencyBRCents(precoPromoCents)}
                      inputMode="numeric"
                      onKeyDown={handlePrecoPromoKeyDown}
                      onPaste={(e) => e.preventDefault()}
                    />
                    <br /><br />

                    <b>Início da Promoção:</b>
                    <DatePicker
                      style={{ width: '100%', marginTop: 4 }}
                      format="DD/MM/YYYY"
                      value={inicioPromo}
                      onChange={setInicioPromo}
                    />
                    <br /><br />

                    <b>Fim da Promoção:</b>
                    <DatePicker
                      style={{ width: '100%', marginTop: 4 }}
                      format="DD/MM/YYYY"
                      value={fimPromo}
                      onChange={setFimPromo}
                    />
                  </div>
                )}
              </Card>
            </Col>
          )
        }
      </Row >
    </div >
  );
};

export default NovoAnuncioMkt;

const styles = {
  wrap: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
};
